export default __webpack_public_path__ + "static/media/not-found.492a643d.svg";